import { Box, Flex } from '@opendoor/bricks/core';

import { EntryComponent } from '../../cms/entries/entries';
import { IComponentAccordionList } from '../../declarations/contentful';
import { Accordion } from '../shared/Accordion';
import { EmbeddedEntryWrapper } from './EmbeddedEntryWrapper';

const renderAccordionList = (entry: IComponentAccordionList) => {
  const items = (entry.fields.items || []).map(({ fields }) => {
    return {
      title: fields?.title || '',
      body: fields?.body || '',
      // TODO: team to add unique panelId to fields and use this instead of title
      panelId: fields?.title || '',
    };
  });

  return (
    <EmbeddedEntryWrapper alignment="text">
      <Flex>
        <Box width="100%">
          {items.map((item) => (
            <Accordion key={item.panelId} {...item} />
          ))}
        </Box>
      </Flex>
    </EmbeddedEntryWrapper>
  );
};

const AccordionList: EntryComponent<IComponentAccordionList> = {
  render: renderAccordionList,
};

export default AccordionList;
